import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const SESSION_TOKEN_KEY = 'notabayar_session_token';
export const BUSINESS_ID_KEY = 'notabayar_business_id';

let isRedirecting = false;

// Attaches the dashboard session token to every API call so the backend knows who is asking
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem(SESSION_TOKEN_KEY) : null;
  const authReq = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  return next(authReq).pipe(
    catchError((err: HttpErrorResponse) => {
      // Session expired or revoked: forget it and reload so the dashboard shows the "link expired" screen.
      // verify-token failures are handled by the dashboard itself.
      if (err.status === 401 && !req.url.includes('/verify-token') && !isRedirecting) {
        isRedirecting = true;
        localStorage.removeItem(SESSION_TOKEN_KEY);
        localStorage.removeItem(BUSINESS_ID_KEY);
        window.location.reload();
      }
      return throwError(() => err);
    })
  );
};
